import React, {useEffect, useState, useRef} from "react";
import PropTypes from "prop-types";
import ReportDataGrid from "../Components/ReportDataGrid";

import { ThemeMode} from "../config";

import { useTheme, styled } from '@mui/material/styles';
import {
  Box,
  ClickAwayListener,
  Collapse,
  Dialog,
  Grid,
  Menu,
  MenuItem,
  Popper,
  Stack,
  TextField,
  Typography,
  useMediaQuery
} from '@mui/material';
import Container from '@mui/material/Container';
import {API} from "aws-amplify";
import MainCard from '../Components/MainCard';
import SimpleBarScroll from '../Components/third-party/SimpleBar'
import ChatHistory from '../sections/apps/chat/ChatHistory'
import IconButton from '../Components/@extended/IconButton';
import { dispatch, useSelector } from '../store/index';
import {
  AudioMutedOutlined,
  CloseOutlined,
  DeleteOutlined,
  DownloadOutlined,
  InfoCircleOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MoreOutlined,
  PaperClipOutlined,
  PhoneOutlined,
  PictureOutlined,
  SendOutlined,
  SmileOutlined,
  SoundOutlined,
  VideoCameraOutlined
} from '@ant-design/icons';
import ChatDrawerParameter from "../sections/apps/chat/ChatDrawerParameter";
import SimpleBar from "simplebar-react";

const drawerWidth = 320;
const apiName = process.env.REACT_APP_ENDPOINT_NAME;
const path_report_rag = process.env.REACT_APP_REPORT_RAG;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(({ theme, open }) => ({
  flexGrow: 1,
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.shorter
  }),
  marginLeft: `-${drawerWidth}px`,
  [theme.breakpoints.down('lg')]: {
    paddingLeft: 0,
    marginLeft: 0
  },
  ...(open && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.shorter
    }),
    marginLeft: 0
  })
}));

const TaxChatBot = (props) => {

    const theme = useTheme();
    const matchDownSM = useMediaQuery(theme.breakpoints.down('lg'));
    const matchDownMD = useMediaQuery(theme.breakpoints.down('md'));
    const [data, setData] = useState([]);
    const user_name = props.user_name;
    const textInput = useRef(null);
    const [message, setMessage] = useState('');
    const [openChatDrawer, setOpenChatDrawer] = useState(true);

    const [top_k_select, setTopK] = useState('');
    const [max_length_select, setMaxLength] = useState('');
    const [top_p_select, setTopP] = useState('');
    const [temperature_select, setTemperature] = useState('');
    const [do_sample_select, setDoSample] = useState('');
    const [language_select, setLanguage] = useState('');

    const handleTopKChange = (event) => {
        setTopK(event.target.value);
    }
    const handleMaxLength = (event) => {
        setMaxLength(event.target.value);
    }

    const handleTopP = (event) => {
        setTopP(event.target.value);
    }

    const handleTemperature = (event) => {
        setTemperature(event.target.value);
    }

    const handleDoSample = (event) => {
        setDoSample(event.target.value);
    }

    const handleLanguage = (event) => {
        setLanguage(event.target.value);
    }

    const handleDrawerOpen = () => {
        setOpenChatDrawer((prevState) => !prevState);
    };


    const handleOnSend = () => {
        if (message.trim() === '' || top_k_select === '' || max_length_select === ''
        || top_p_select==='' || temperature_select === '' || do_sample_select === ''
        || language_select === '') {
          window.alert("Please make sure you have a message and valid Tax Bot Parameters.");
          return null;
        } else {
          const d = new Date();
          const newMessage = {
            text: message,
            from: user_name,
              time: d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
          };
          let prev_data = data;
          prev_data.push(newMessage);
          let data_to_send = [];
          let sum = 0;
          let cumulativeSum = [];
          prev_data.reverse()
          prev_data.forEach((item) => {
              sum = sum + item.text.length;
              cumulativeSum.push(sum)
              if (sum < 1000){
                  data_to_send.push(item);
              }
          });
          prev_data.reverse()
          setData(prev_data); //set data to message sent
          //API call
          var myInit = {};
          myInit = {
              headers: {},
              response: true,
              queryStringParameters: {
                  data: JSON.stringify(data_to_send),
                  top_k_select: JSON.stringify(top_k_select),
                  max_length_select: JSON.stringify(max_length_select),
                  top_p_select: JSON.stringify(top_p_select),
                  temperature_select: JSON.stringify(temperature_select),
                  do_sample_select: JSON.stringify(do_sample_select),
                  language_select: JSON.stringify(language_select)
              }
          };
          API.get(apiName, path_report_rag, myInit)
              .then(response => {
                console.log(response);
                // Check status code. If 200 then do below. Else if 209 display message.
                let generated_text:string = response['data']['generated_text'];
                let metadata_page:string = response['data']['documents'][0]['metadata']['page']
                let metadata_url:string = response['data']['documents'][0]['metadata']['presigned_url']
                let metadata_message = "\nYou can find the relevant section at page " + metadata_page + " from: ";
                // let current_chat:[] = data;
                let resp_d = new Date();
                let botMessage = {
                  text: generated_text + metadata_message,
                  from: "Tax Bot",
                  url: metadata_url,
                  time: resp_d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                };
                prev_data.push(botMessage);
              setData(prev_data);
              setMessage('');
              }).catch(error =>{
                  console.log(error);
                  console.log(error.message);
          })

        }
        setMessage('Please wait for response');
  };
    const handleEnter = (event) => {
      if (event?.key !== 'Enter') {
        return;
      }
      handleOnSend();
    };

    return (
        <Container maxWidth="lg" sx={{paddingTop: '10%'}}>
          <Box sx={{ display: 'flex' }}>
              <ChatDrawerParameter
                  openChatDrawer={openChatDrawer}
                  handleDrawerOpen={handleDrawerOpen}
                  top_k_select={top_k_select}
                  handleTopKChange={handleTopKChange}
                  max_length_select={max_length_select}
                  handleMaxLength={handleMaxLength}
                  top_p_select={top_p_select}
                  handleTopP={handleTopP}
                  temperature_select={temperature_select}
                  handleTemperature={handleTemperature}
                  do_sample_select={do_sample_select}
                  handleDoSample={handleDoSample}
                  language_select={language_select}
                  handleLanguage={handleLanguage}
              />
            <Main theme={theme} open={openChatDrawer}>
                <Grid container>
                    <Grid
                        item
                        xs={12}
                        md={8}
                        xl={9}
                        sx={{
                            transition: theme.transitions.create('width',{
                                easing: theme.transitions.easing.easeOut,
                                duration: theme.transitions.duration.shorter + 200
                            })
                        }}
                    >
                        <MainCard
              content={false}
              sx={{
                bgcolor: theme.palette.mode === ThemeMode.DARK ? 'dark.main' : 'grey.50',
                pt: 2,
                pl: 2,
                borderRadius: '0',
                transition: theme.transitions.create('width', {
                  easing: theme.transitions.easing.easeOut,
                  duration: theme.transitions.duration.shorter + 200
                })
              }}
            >
              <Grid container spacing={3}>
                <Grid
                  item
                  xs={12}
                  sx={{
                    bgcolor: theme.palette.background.paper,
                    pr: 2,
                    pb: 2,
                    borderBottom: `1px solid ${theme.palette.divider}`
                  }}
                >
                  <Grid container justifyContent="space-between">
                    <Grid item>
                      <Stack direction="row" alignItems="center" spacing={1}>
                          <IconButton onClick={handleDrawerOpen} color="secondary" size="large">
                              {openChatDrawer ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
                          </IconButton>
                        <Stack>
                          <Typography variant="subtitle1">Tax Chat Bot</Typography>
                          <Typography variant="caption" color="textSecondary">
                            Please ask any tax related query.
                          </Typography>
                        </Stack>
                      </Stack>
                    </Grid>
                  </Grid>
                    <Grid item xs={12}>
                        <SimpleBarScroll
                            sx={{
                                overflowX: 'hidden',
                                height: 'calc(100vh - 410px)',
                                minHeight: 420
                            }}
                            >
                    <Box sx={{ pl: 1, pr: 3 }}>
                      <ChatHistory theme={theme} data={data} user={user_name}/>
                    </Box>
                        </SimpleBarScroll>
                    </Grid>
                  <Grid item xs={12} sx={{ mt: 3, bgcolor: theme.palette.background.paper, borderTop: `1px solid ${theme.palette.divider}` }}>
                  <Stack>
                    <TextField
                      inputRef={textInput}
                      fullWidth
                      multiline
                      rows={4}
                      placeholder="Your Message..."
                      value={message}
                      onChange={(e) => setMessage(e.target.value.length <= 1 ? e.target.value.trim() : e.target.value)}
                      onKeyPress={handleEnter}
                      variant="standard"
                      sx={{
                        pr: 2,
                          // height: 'calc(100vh - 501px)',
                        '& .MuiInput-root:before': { borderBottomColor: theme.palette.divider }
                      }}
                    />
                      <Stack direction="row" justifyContent="space-between" alignItems="center">
                          <Stack direction="row" sx={{py:2, ml: -1}}>

                          </Stack>
                          <IconButton color="primary" onClick={handleOnSend} size="large" sx={{ mr: 1.5 }}>
                            <SendOutlined />
                          </IconButton>
                      </Stack>
                  </Stack>
                </Grid>
                  </Grid>
                </Grid>
              </MainCard>
                    </Grid>
                </Grid>
            </Main>

          </Box>
        </Container>
      )
}

TaxChatBot.propTypes = {
    user_name: PropTypes.string
}

export default TaxChatBot;